import { ITransportador } from "./Transportador";
import { LogTipos, LoggerConfiguracionToken, LoggerTransportadorToken } from "./Utilidades";
import { Inject, Optional, Injectable } from "@angular/core";
import { LoggerConfiguracion } from "./LoggerConfiguracion";
import { ConsolaTransportador } from "./transportadores/ConsolaTransportador";
import { PayloadError } from "./PayloadError";

export abstract class ILogger {
    abstract debug(payload: PayloadError): void;
    abstract error(payload: PayloadError): void;
    abstract info(payload: PayloadError): void;
    abstract warning(payload: PayloadError): void;
}

@Injectable({
    providedIn: "root"
})
export class Logger implements ILogger {
    private transportadores: ITransportador[] = [];

    constructor(@Inject(LoggerConfiguracionToken) private loggerConfiguracion: LoggerConfiguracion,
        @Optional() @Inject(LoggerTransportadorToken) private transportadoresPropios?: ITransportador[]) {

        if (this.loggerConfiguracion.transportadores.consola) {
            this.transportadores.push(new ConsolaTransportador());
        }

        if (this.transportadoresPropios) {
            this.transportadores.push(...this.transportadoresPropios);
        }
    }

    public error(payload: PayloadError): void {
        this.enviarMensaje(payload, LogTipos.ERROR);
    }

    public info(payload: PayloadError): void {
        this.enviarMensaje(payload, LogTipos.INFO);
    }
    public warning(payload: PayloadError): void {
        this.enviarMensaje(payload, LogTipos.WARNING);
    }

    public debug(payload: PayloadError): void {
        this.enviarMensaje(payload, LogTipos.DEBUG);
    }

    private enviarMensaje(payload: PayloadError, tipo: LogTipos) {
        this.transportadores.forEach(transportador => {
            queueMicrotask(() => transportador.escribir(payload, tipo));
        });
    }
}
